import { useState } from 'react'
import PurchaseMember from './PurchaseMember';
import { useStore } from '../../../core/utils/hook';
import { flowResult } from 'mobx';
import { ACCOUNT_STATUS } from '../../../core/configs/constants';


export default function LockFreeAccount({cb, hidden = false}) {
    // store
    const { authStore: { accountInfo, getInfo, getAccInfo },
        modalStore: { hide, show } } = useStore();
    //state
    const [navigateToPaidMember, setNavigate] = useState(false);
    const [isShow, setShow] = useState(false);
    
    //function
    const onChangeNavigate = (value) => {
        setNavigate(value);
        cb && cb(false);
    }

    const onCheckAndShowModalError = async () => {
        let acc = await flowResult(getAccInfo(true));
        let checkShowModalRefresh = false;
        if (acc) {
            checkShowModalRefresh = acc.status == ACCOUNT_STATUS.SUBSCRIBED.key;
        }
        if (checkShowModalRefresh) {
            show({
                id: 'modal-error',
                header: '',
                isOpen: true,
                onCancel: () => {
                    hide();
                    window.location.reload();
                },
                children: (<div className='pd-tb-20 pd-lr-16'>
                    <p className='fs-label text-center font-semi-bold'>アカウント情報が更新されました。最新の内容を反映するには、ページを再読み込みしてください。</p>
                    <div className='mg-t-30 modal-footer-group d-flex align-items-center justify-content-center flex-wrap'>
                        <button className='btn btn-bg-cs-1 min-width-130' onClick={() => {
                            window.location.reload();
                        }}>再読み込み </button>
                    </div>
                </div>)
            })
        } else {
            cb && cb(true);
            setNavigate(!navigateToPaidMember)
        }
    }

    return !hidden ? !navigateToPaidMember ? (
        <div className='modal-absolute-overlay modal-paid-member pd-tb-20 pd-lr-16 '>
            <div className='w-100 text-center'><img src='/images/icon_lock_card.svg'
                className='mg-b-15 text-center text-white'/></div>
            <p className='fs-heading-normal text-center font-semi-bold'>ホルダー一覧を拡充するには、会員登録が必要です。</p>
            <div className='d-flex justify-content-center mg-t-30 mg-b-15'>
                <button 
                    className='btn btn-bg-cs-1 min-width-150' 
                    onClick={() => {
                        onCheckAndShowModalError();
                    }}>
                    <span className='font-bold'>有料会員はコチラから</span>
                </button>
            </div>
        </div>
    ) : (
        <PurchaseMember 
            navigateToPaidMember={navigateToPaidMember} 
            onChangeNavigate={onChangeNavigate} 
            callbackSendMailMessage={() => {
                setShow(isShow);
                setNavigate(!navigateToPaidMember);
                cb && cb(false);
            }}
            callbackSubmit={() => {
                setShow(!isShow);
            }}
        />
        
    ) : <></>
}